// extracted by mini-css-extract-plugin
export default {"root":"IEWarning__root--hH7NM"};